export const THEME_NAMES = ["light", "dark", "amoled", "system"] as const;
export type ThemeName = (typeof THEME_NAMES)[number];
export type ResolvedTheme = Exclude<ThemeName, "system">;

export const META_THEME_COLORS: Record<ResolvedTheme, string> = {
  light: "#F8F2EA",
  dark: "#211C19",
  amoled: "#050403",
};

export const STORAGE_KEY = "habits-theme";
